<div class="canvas-editor custom-scrollbar">
  <div class="canvas-header">
    <div class="header-left">
      <button mat-icon-button class="toggle-sidebar-btn" (click)="sidenavService.toggle()">
        <mat-icon>{{ sidenavService.isSmallOrTablet() ? 'menu' : 'left_panel_open' }}</mat-icon>
      </button>
      <mat-icon class="header-icon">description</mat-icon>
      <h2>{{ title }}</h2>
    </div>

    @if (isWriter()) {
      <div id="header-toolbar">
        <span class="ql-formats">
          <button mat-icon-button (click)="undo()" [disabled]="!canUndo()" matTooltip="Undo">
            <mat-icon>undo</mat-icon>
          </button>
          <button mat-icon-button (click)="redo()" [disabled]="!canRedo()" matTooltip="Redo">
            <mat-icon>redo</mat-icon>
          </button>
        </span>

        <span class="divider"></span>

        <span class="ql-formats text-style-formats">
          <button mat-button [matMenuTriggerFor]="headerMenu" class="header-dropdown-btn" matTooltip="Text style">
            <mat-icon class="dropdown-icon-left">format_size</mat-icon>
            <span class="dropdown-text">{{ currentHeaderLabel() | translate }}</span>
            <mat-icon class="arrow-icon">arrow_drop_down</mat-icon>
          </button>
          <mat-menu #headerMenu="matMenu">
            @for (option of headerOptions; track option.id) {
              <button mat-menu-item (click)="applyHeader(option.id)">
                <mat-icon>{{ option.icon }}</mat-icon>
                <span>{{ option.text | translate }}</span>
              </button>
            }
            <mat-divider></mat-divider>
            <button mat-menu-item (click)="clearFormatting()">
              <mat-icon>format_clear</mat-icon>
              <span>{{ 'Clear Formatting' | translate }}</span>
            </button>
          </mat-menu>
        </span>

        <span class="divider"></span>

        <span class="ql-formats">
          <button class="ql-bold" mat-icon-button matTooltip="Bold"><mat-icon>format_bold</mat-icon></button>
          <button class="ql-italic" mat-icon-button matTooltip="Italic"><mat-icon>format_italic</mat-icon></button>
          <button class="ql-underline" mat-icon-button matTooltip="Underline"><mat-icon>format_underlined</mat-icon></button>
          <button class="ql-code" mat-icon-button [matTooltip]="'Quill.Tooltip.Code' | translate"><mat-icon>code</mat-icon></button>
        </span>

        <span class="divider"></span>

        <span class="ql-formats">
          <button class="ql-list" value="ordered" mat-icon-button matTooltip="Ordered list"><mat-icon>format_list_numbered</mat-icon></button>
          <button class="ql-list" value="bullet" mat-icon-button matTooltip="Bullet list"><mat-icon>format_list_bulleted</mat-icon></button>
        </span>
      </div>
    }

    <div class="actions">
      @if ((contentStateService.isLiveTranscribing() && contentStateService.liveTranscriptionSource() === 'recorder') || (source === 'transcript' && isWriter())) {
        <app-audio-recorder
          [compact]="true"
          [hideWaveform]="true"
          [contentID]="contentId"
          [continueTranscriptionMode]="true"
          [currentText]="editableContent"
          [params]="{ _id: chunkId }"
        ></app-audio-recorder>
      }

      @if (chunkId) {
        @if (isGeneratingAudio()) {
          <mat-spinner diameter="18"></mat-spinner>
        } @else {
          <button mat-icon-button btnType="action-icon" (click)="togglePlayback()" [matTooltip]="(isPlaying() ? 'AudioPlayer.Tooltip.Pause' : 'AudioPlayer.Tooltip.Play') | translate" [disabled]="isGeneratingAudio()">
            <mat-icon>{{ isPlaying() ? 'pause' : 'play_arrow' }}</mat-icon>
          </button>
        }
      }

      @if (isWriter()) {
        @if (source !== 'transcript') {
          <app-live-dictation-button [chunkId]="chunkId" [contentId]="contentId"></app-live-dictation-button>
        }
        <button mat-icon-button btnType="action-icon" (click)="saveEdit()" [matTooltip]="'Global.Save' | translate">
          <mat-icon>save</mat-icon>
        </button>

        @if (isInserting()) {
          <mat-spinner diameter="18"></mat-spinner>
        } @else {
          <button mat-icon-button btnType="action-icon" (click)="confirmInsert($event)" [matTooltip]="'ContentRefiner.InsertButton' | translate" [disabled]="isInserting()">
            <mat-icon>arrow_downward</mat-icon>
          </button>
        }
      }

      @if (source === 'transcript' && chunkId) {
        <button mat-icon-button btnType="action-icon" (click)="toggleContentGenerator()" [matTooltip]="(contentStateService.isGeneratorOpen() ? 'ContentGenerator.Close' : 'ContentGenerator.Open') | translate">
          <mat-icon>{{ contentStateService.isGeneratorOpen() ? 'right_panel_close' : 'right_panel_open' }}</mat-icon>
        </button>
      }

      <button mat-icon-button (click)="onClose()" [matTooltip]="'Global.Close' | translate">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <div class="canvas-content custom-scrollbar" #canvasContent>
    <quill-editor
      #editor
      (onEditorCreated)="onEditorCreated($event)"
      [(ngModel)]="editableContent"
      [modules]="quillModules"
      (onContentChanged)="onContentChanged($event)"
      (onSelectionChanged)="onSelectionChanged($event)"
      [placeholder]="'Global.StartWriting' | translate"
      [readOnly]="!isWriter()"
    ></quill-editor>
  </div>
</div>
